<script>
  import { createEventDispatcher } from "svelte";
  import NotificationModal from "../../../Components/Common/NotificationModal.svelte";
  import { EditRepeatingEventOptions } from "../../../Utils/utilEnums.svelte";

  export let isModalOpen = false,
    wasEventRepeating,
    accountEventObj = {};

  let noticeText = "",
    editOption;

  const dispatch = createEventDispatcher();

  const closeModal = () => {
    isModalOpen = false;
    editOption = undefined;
    wasEventRepeating = undefined;
  };

  const confirmEdit = () => {
    dispatch("proceedAction", editOption);
    closeModal();
  };
</script>

<NotificationModal
  title="Edit Repeating Event"
  submitText="Update"
  {isModalOpen}
  {closeModal}
  closeModalFunction={closeModal}
  confirmAction={confirmEdit}
  isConfirmDisabled={!editOption}
>
  <div class="flex flex-col gap-y-4 font-medium">
    {#if wasEventRepeating && !accountEventObj.isRepeating}
      <p class="text-error">
        You are trying to cancel repeating for this event, would you like to:
      </p>
      <label class="flex items-center gap-4">
        <input
          type="radio"
          class="radio radio-secondary"
          value={EditRepeatingEventOptions.thisOnly}
          bind:group={editOption}
        />
        Edit this event only
      </label>
      <label class="flex items-center gap-4">
        <input
          type="radio"
          class="radio radio-secondary"
          value={EditRepeatingEventOptions.thisAndFollowing}
          bind:group={editOption}
        />
        Edit this event and delete following events
      </label>
    {:else}
      <label class="flex items-center gap-4">
        <input
          type="radio"
          class="radio radio-secondary"
          value={EditRepeatingEventOptions.thisOnly}
          bind:group={editOption}
        />
        This event only
      </label>
      <label class="flex items-center gap-4">
        <input
          type="radio"
          class="radio radio-secondary"
          value={EditRepeatingEventOptions.thisAndFollowing}
          bind:group={editOption}
        />
        This and following events
      </label>
    {/if}
  </div>
</NotificationModal>
